import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import TrailerViewer from "./trailerViewer";

const TrailerSlider = ({ items, showOnly = 0 }) => {
  const settings = {
    dots: showOnly > 0,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const itemsToShow = showOnly > 0 ? items.slice(0, showOnly) : items;

  if (itemsToShow.length === 0) {
    return undefined;
  }

  return (
    <div className="trailer-slider-container">
      <Slider {...settings}>
        {itemsToShow.map((item) => (
          <div key={item.id} style={{ display: "block", margin: "0 10px" }}>
            <TrailerViewer itemId={item.id} videoId={item.trailerUrl} />
            <div className="trailer-link">
              <Link to={`/book/${item.id}`}>{item.title}</Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TrailerSlider;
